export default __webpack_public_path__ + "static/media/redux.4eddbf10.png";